import { useList } from "@inmagik/react-crud"
import { API_URL } from "../constants"
import { RegolaConsegna } from "../types"

export function useRegoleConsegnaList(params: Record<string, string | string[] | number[] | number> = {}) {
  return useList<RegolaConsegna>(`${API_URL}/regole-consegna`, { query: params })
}
